<template>
  <div class="wrapper" style="padding-top: 50px">
    <b-form @submit="onSubmit($event)">
      <div class="log_in_text">
        <h3><b>Log in</b></h3>
      </div>
      <div class="input-wrapper">
        <label class="app-input-label" for="loginId">Username</label>
        <input
          type="text"
          class="app-input"
          id="loginId"
          v-model="form.username"
        />
      </div>

      <div class="input-wrapper">
        <label for="loginPassword">Password</label>
        <input
          type="password"
          class="app-input"
          id="loginPassword"
          v-model="form.password"
        />
      </div>

      <div class="input-wrapper">
        <label for="scanEntry"
          >Entry ID
          <span class="fs-14" v-if="entry_id_required == 'N'"
            >(Optional)</span
          ></label
        >
        <div class="d-flex align-items-center">
          <div class="input-material w-100">
            <input
              type="text"
              @input="onInputEntryId"
              :class="
                submitted && validEntryId
                  ? 'valid-field'
                  : submitted && !validEntryId
                  ? 'Invalid-field'
                  : ''
              "
              class="app-input"
              id="scanEntry"
              v-model="form.entry_id"
            />
            <span class="scanner-icon" @click="scanEntryPoint(true)">
              <img src="@/assets/img/scanner.svg" height="35" width="30" />
            </span>
            <div
              v-if="EntryMsg"
              class="msg-tag"
              :class="validEntryId ? 'validmsg' : 'invalidmsg'"
            >
              {{ EntryMsg }}
            </div>
          </div>
        </div>

        <div v-if="entryScanner" class="qrcode-entry-container">
          <div class="close-scanner-icon" @click="scanEntryPoint(false)">
            <img
              src="@/assets/img/cancel-cross-icon.svg"
              height="35"
              width="30"
            />
          </div>
          <qrcode-stream @decode="onDecode" @init="onInit"></qrcode-stream>
          <div
            class="mx-auto text-center justify-content-center mb-3"
            v-if="loadingCamera"
          >
            <b-spinner
              variant="dark"
              type="grow"
              label="Spinning"
              class="translate-spinner"
              style="width: 3rem; height: 3rem"
            ></b-spinner>
            <br />
            <div class="d-block">Checking Camera...</div>
          </div>
        </div>
      </div>
      <button class="btn-app-submit">Submit</button>
    </b-form>
  </div>
</template>

<script>
import BookingService from "@/services/BookingService";
import _ from "lodash";
export default {
  name: "Login",
  data() {
    return {
      form: {
        username: "",
        password: "",
        entry_id: "",
        food: null,
        checked: [],
      },
      show: true,
      entryScanner: false,
      validEntryId: false,
      submitted: false,
      EntryMsg: "",
      entry_id_required: "N",
      loadingCamera: false,
    };
  },
  beforeMount() {
    this.GetGlobalOptions();
    if (window.localStorage.getItem("STBASEDENTRY")) {
      this.entry_id_required = window.localStorage.getItem("STBASEDENTRY");
    } else {
      this.entry_id_required = "N";
    }
  },
  methods: {
    onInputEntryId: _.debounce(function (query) {
      if (this.form.entry_id.length > 3) {
        this.verifyEntryId(this.form.entry_id);
      }
    }, 1 * 1000),
    async onInit(promise) {
      this.loadingCamera = true;
      try {
        this.errorStatus = false;
        await promise;
      } catch (error) {
        this.errorStatus = true;
        if (error.name === "NotAllowedError") {
          this.error = "ERROR: you need to grant camera access permisson";
        } else if (error.name === "NotFoundError") {
          this.error = "ERROR: no camera on this device";
        } else if (error.name === "NotSupportedError") {
          this.error = "ERROR: secure context required (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "ERROR: is the camera already in use?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "ERROR: installed cameras are not suitable";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "ERROR: Stream API is not supported in this browser";
        }
      }
      setTimeout((x) => {
        this.loadingCamera = false;
      }, 100);
    },
    GetGlobalOptions: function () {
      BookingService.GetGlobalOptions()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            let EntrySettings = data.Records.filter(
              (x) => x.go_key == "ENTRY_ID_REQUIRED_QRAPP"
            );
            console.log(EntrySettings, "EntrySettings");
            if (EntrySettings && EntrySettings.length > 0) {
              this.entry_id_required = EntrySettings[0].go_value;

              window.localStorage.setItem(
                "STBASEDENTRY",
                EntrySettings[0].go_value
              );
            } else {
              window.localStorage.setItem("STBASEDENTRY", "N");
            }
          } else {
            window.localStorage.setItem("STBASEDENTRY", "N");
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("catch error on GetGlobalOptions :", error);
        });
    },
    onDecode(decodedString) {
      console.log("decodedString", decodedString);
      this.form.entry_id = decodedString;
      if (decodedString) {
        this.verifyEntryId(decodedString);
      }
    },
    verifyEntryId(entry_id) {
      let payload = {
        entry_id: entry_id,
      };
      let loader = this.$loading.show();
      BookingService.validateEntryId(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.validEntryId = true;
            this.EntryMsg = "Valid";
          } else {
            this.validEntryId = false;
            console.log("Error", data);
            this.EntryMsg = "Invalid";
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("Catch Error", err);
        })
        .finally(() => {
          this.submitted = true;
          this.entryScanner = false;
          loader.hide();
        });
    },
    scanEntryPoint(status = true) {
      this.entryScanner = status;
    },
    onSubmit: function (e) {
      e.preventDefault();
      console.log("test");
      let success = true;

      if (!this.form.password) {
        return this.$toasted.show("Please Enter Password");
      } else if (!this.form.username) {
        return this.$toasted.show("Please Enter Username");
      } else if (this.entry_id_required == "Y" && !this.form.entry_id) {
        return this.$toasted.show("Please Enter Entry ID");
      } else if (this.form.entry_id && !this.validEntryId) {
        return this.$toasted.show("Please Enter Valid Entry ID");
      } else {
        // api call
        let payload = {
          password: this.form.password,
          username: this.form.username,
        };
        let loader = this.$loading.show();

        BookingService.userpasswordconfirm(payload)
          .then((response) => {
            const { data } = response;
            loader.hide();
            if (data && data.status) {
              if (
                (data.data &&
                  data.data.user &&
                  data.data.user.role_name == "Entry Manager") ||
                (data.data &&
                  data.data.user &&
                  data.data.user.role_name == "POS Operator")
              ) {
                window.localStorage.setItem("JWT_TOKEN", data.data.token);

                let finalObj = {};

                Object.keys(data.data.user).map((x) => {
                  finalObj[x] = data.data.user[x];
                });

                window.localStorage.setItem(
                  "USERCINEINFO",
                  data.data.user.cine_id
                );

                if (this.form.entry_id) {
                  let EntryID = this.form.entry_id || null;
                  window.localStorage.setItem("SEID", EntryID); //Screen Entry ID Based on Seat Type in Screens
                } else {
                  window.localStorage.removeItem("SEID");
                }

                this.$cookie.set("BRHSID", data.data.token, {
                  expires: "1Y",
                });

                this.$cookie.set("BRLF", "admin-login");

                this.$router.push({
                  name: "qrCode",
                });
              } else {
                this.$toasted.show(
                  "Please Login as Entry Manager or POS Operator"
                );
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            loader.hide();
            console.log("ERROR; in LOGIN", error);
            this.$toasted.show("Something went wrong!");
          });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.scanner-icon {
  position: relative;
  float: right;
  right: 10px;
  bottom: 40px;
}

.valid-field,
.valid-field:focus {
  border: 2px solid green;
  border-radius: 6px;
  color: green !important;
}

.msg-tag {
  font-size: 13px;
  font-style: italic;
}

.msg-tag .validmsg {
  color: green;
}

.msg-tag .Invalidmsg {
  color: red;
}

.Invalid-field,
.Invalid-field:focus {
  border: 2px solid red;
  border-radius: 6px;
  color: red !important;
}

.close-scanner-icon {
  float: right;
  right: 50px;
  top: 5px;
  position: relative;
  z-index: 10000;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue